// 账户与身份统一入口：语言字段在同目录维护，逻辑与显示映射在此集中管理。
import * as simplified from "./zh-CN.js";
import * as traditional from "./zh-HK.js";
import * as english from "./en-US.js";
export const zhCN = simplified.messages;
export const zhHK = traditional.messages;
export const enUS = english.messages;

// 分区导出保留原有接口，词条只在语言文件中保存一份。
export const authZhCN = simplified.auth;
export const authZhHK = traditional.auth;
export const authEnUS = english.auth;
export const mobileLoginZhCN = simplified.mobileLogin;
export const mobileLoginZhHK = traditional.mobileLogin;
export const mobileLoginEnUS = english.mobileLogin;
export const accountSettingsZhCN = simplified.settings;
export const accountSettingsZhHK = traditional.settings;
export const accountSettingsEnUS = english.settings;
export const pcCompanyInfoZhCN = simplified.company;
export const pcCompanyInfoZhHK = traditional.company;
export const pcCompanyInfoEnUS = english.company;
export const mobileRealnameZhCN = simplified.mobileRealname;
export const mobileRealnameZhHK = traditional.mobileRealname;
export const mobileRealnameEnUS = english.mobileRealname;
export const pcRealnameZhCN = simplified.desktopRealname;
export const pcRealnameZhHK = traditional.desktopRealname;
export const pcRealnameEnUS = english.desktopRealname;
export const pcPersonalMenuZhCN = simplified.menu;
export const pcPersonalMenuZhHK = traditional.menu;
export const pcPersonalMenuEnUS = english.menu;
export const pcWalletZhCN = simplified.desktopWallet;
export const pcWalletZhHK = traditional.desktopWallet;
export const pcWalletEnUS = english.desktopWallet;
export const mobileWalletZhCN = simplified.mobileWallet;
export const mobileWalletZhHK = traditional.mobileWallet;
export const mobileWalletEnUS = english.mobileWallet;

export const menuLabelKeys = Object.freeze({
  出货管理: "personalMenu.outboundManagement",
  合同译文审核: "personalMenu.contractTranslation",
  动态译文管理: "personalMenu.contentTranslation",
  精选交易: "personalMenu.featuredTrading",
  我的钱包: "personalMenu.wallet",
  数据看板: "personalMenu.reportDashboard",
  交易订单: "personalMenu.orders",
  商品中心: "personalMenu.goodsCenter",
  商品库: "personalMenu.goodsLibrary",
  品牌管理: "personalMenu.brands",
  供应商管理: "personalMenu.suppliers",
  消息管理: "personalMenu.messages",
  供应需求: "personalMenu.supplyDemand",
  供应发布: "personalMenu.postSupply",
  需求发布: "personalMenu.postDemand",
  简洁供应发布: "personalMenu.quickSupply",
  简洁需求发布: "personalMenu.quickDemand",
  批量发布: "personalMenu.bulkPost",
  客户管理: "personalMenu.customerManagement",
  我的客户: "personalMenu.myCustomers",
  我的订单: "personalMenu.myOrders",
  会员等级: "personalMenu.memberLevel",
  等级列表: "personalMenu.levelList",
  等级申请: "personalMenu.levelApplication",
  等级权益: "personalMenu.levelBenefits",
  会员身份: "personalMenu.memberIdentity",
  身份列表: "personalMenu.identityList",
  业务员: "personalMenu.salesperson",
  客户: "personalMenu.customer",
  供应商: "personalMenu.supplier",
  合作伙伴: "personalMenu.partner",
  竞标管理: "personalMenu.bidManagement",
  竞标审核: "personalMenu.bidReview",
  竞标列表: "personalMenu.bidList",
  发布竞标: "personalMenu.postBid",
  我的竞标: "personalMenu.myBids",
  我的跟单员: "personalMenu.myFollowers",
  我的跟单: "personalMenu.myFollowUps",
  我的收藏: "personalMenu.favorites",
  知识百科: "personalMenu.wiki",
  审核管理: "personalMenu.reviewManagement",
  我的发布: "personalMenu.myPosts",
  我的问答: "personalMenu.myQuestions",
  规格书管理: "personalMenu.specifications",
  账号设置: "personalMenu.accountSettings",
  个人资料: "personalMenu.personalInfo",
  企业资料: "personalMenu.companyInfo",
  安全设置: "personalMenu.security",
  账号认证: "personalMenu.verification",
  价格频道: "personalMenu.priceChannel",
  频道身份: "personalMenu.channelIdentity",
  消息中心: "personalMenu.messageCenter",
  行情自选: "personalMenu.watchlists",
  企业认证: "personalMenu.certification",
  业务上报: "personalMenu.submissions",
  审核待办: "personalMenu.reviewQueue",
  审查结果: "personalMenu.reviewResults",
});

// 仅把既有固定中文标签映射到语义键；用户填写的企业正文和未知标签原样回退。
const companyInfoUiKeys = Object.freeze({
  公司信息: "companyInfo.companyInformation",
  收货信息: "companyInfo.shippingInformation",
  联系人: "companyInfo.contacts",
  子公司管理: "companyInfo.subsidiaries",
  "+ 添加地址": "companyInfo.addAddressAction",
  "+ 添加联系人": "companyInfo.addContactAction",
  营业执照: "companyInfo.businessLicense",
  所在地区: "companyInfo.region",
  大陆: "companyInfo.mainlandChina",
  港澳台: "companyInfo.hongKongMacaoTaiwan",
  上传营业执照: "companyInfo.uploadBusinessLicense",
  发证机关: "companyInfo.issuingAuthority",
  请输入文字: "companyInfo.enterText",
  有效期: "companyInfo.validityPeriod",
  选择开始日期: "companyInfo.selectStartDate",
  选择结束日期: "companyInfo.selectEndDate",
  基本资料: "companyInfo.basicInformation",
  公司中文名称: "companyInfo.companyNameChinese",
  公司英文名称: "companyInfo.companyNameEnglish",
  公司简称: "companyInfo.shortName",
  公司税号: "companyInfo.taxId",
  供应商编码: "companyInfo.supplierCode",
  绑定公司: "companyInfo.linkedCompany",
  设为主公司: "companyInfo.setAsParentCompany",
  设为子公司: "companyInfo.setAsSubsidiary",
  "负责人/法人": "companyInfo.personInChargeLegalRepresentative",
  公司电话: "companyInfo.companyPhone",
  公司地址: "companyInfo.companyAddress",
  企业logo: "companyInfo.companyLogo",
  "建议上传 120 x 120 像素的图片": "companyInfo.recommendedImageSize120120Px",
  财务开票资料: "companyInfo.billingInformation",
  开票资料: "companyInfo.invoiceDetails",
  "上传开票资料（银行信息盖章版本）":
    "companyInfo.uploadStampedBankAndBillingDetails",
  上传开票资料: "companyInfo.uploadInvoiceDetails",
  银行账号管理: "companyInfo.bankAccounts",
  银行账号: "companyInfo.bankAccount",
  "+ 增加": "companyInfo.addAction",
  删除: "companyInfo.delete",
  开户银行: "companyInfo.bankName",
  开户支行: "companyInfo.bankBranch",
  银行简称: "companyInfo.bankShortName",
  设为默认银行: "companyInfo.setAsDefaultBank",
  默认银行: "companyInfo.defaultBank",
  银联号: "companyInfo.bankRoutingNumber",
  银行付款资料附件: "companyInfo.paymentDetailsAttachment",
  上传附件: "companyInfo.uploadAttachment",
  补充资料: "companyInfo.additionalInformation",
  公司类型: "companyInfo.companyType",
  有限责任公司: "companyInfo.limitedLiabilityCompany",
  股份有限公司: "companyInfo.jointStockCompany",
  个人独资企业: "companyInfo.soleProprietorship",
  合伙企业: "companyInfo.partnership",
  经营品类: "companyInfo.productCategories",
  经营品类一: "companyInfo.productCategory1",
  经营品类二: "companyInfo.productCategory2",
  经营品牌一: "companyInfo.brand1",
  经营品牌二: "companyInfo.brand2",
  范围一: "companyInfo.scope1",
  范围二: "companyInfo.scope2",
  范围三: "companyInfo.scope3",
  品类一: "companyInfo.category1",
  品类二: "companyInfo.category2",
  品类三: "companyInfo.category3",
  发证机关名称: "companyInfo.issuingAuthorityName",
  消费电子: "companyInfo.consumerElectronics",
  工业控制: "companyInfo.industrialControl",
  汽车电子: "companyInfo.automotiveElectronics",
  能源控制: "companyInfo.energyControl",
  智能安防: "companyInfo.smartSecurity",
  应用领域: "companyInfo.applications",
  "例如 消费电子、工业控制、汽车电子、LED、能源控制、智能安防、家用电器等":
    "companyInfo.applicationIndustryExamples",
  经营品牌: "companyInfo.brands",
  经营范围: "companyInfo.businessScope",
  "请填写主要经营范围，点击添加输入字符，按回车确认":
    "companyInfo.enterYourMainBusinessAreasThenPressEnterToAddEachOne",
  添加: "companyInfo.add",
  主要产品: "companyInfo.mainProducts",
  "请填写主要产品，点击添加输入字符，按回车确认":
    "companyInfo.enterYourMainProductsThenPressEnterToAddEachOne",
  公司介绍: "companyInfo.companyIntroduction",
  资历证书: "companyInfo.certificates",
  荣誉资质: "companyInfo.honorsAndQualifications",
  "支持自主品牌证书、代理品牌证书、资质证书的上传":
    "companyInfo.uploadOwnBrandAgencyBrandAndQualificationCertificates",
  重置: "companyInfo.reset",
  保存: "companyInfo.save",
  收货地址: "companyInfo.shippingAddress",
  默认: "companyInfo.default",
  编辑: "companyInfo.edit",
  收货联系人: "companyInfo.shippingContacts",
  设为默认: "companyInfo.setAsDefault",
  中文名: "companyInfo.chineseName",
  英文名: "companyInfo.englishName",
  手机号码: "companyInfo.mobileNumber",
  微信: "companyInfo.wechat",
  座机: "companyInfo.landline",
  更多: "companyInfo.more",
  操作: "companyInfo.actions",
  公司名称: "companyInfo.companyName",
  法人: "companyInfo.legalRepresentative",
  所在地: "companyInfo.location",
  子公司: "companyInfo.subsidiary",
  切换: "companyInfo.switch",
  详情: "companyInfo.details",
  企业资料详情: "companyInfo.companyDetails",
  编辑企业资料: "companyInfo.editCompanyDetails",
  文件: "companyInfo.file",
  设为默认收货地址: "companyInfo.setAsDefaultShippingAddress",
  "上传营业执照（自动识别营业执照文字信息）":
    "companyInfo.uploadABusinessLicenseToRecognizeItsText",
  查看附件: "companyInfo.viewAttachment",
  付款资料: "companyInfo.paymentDetails",
  联行号: "companyInfo.interbankRoutingNumber",
  重新上传: "companyInfo.uploadAgain",
  图片识别: "companyInfo.recognizeImage",
  粘贴并识别: "companyInfo.pasteAndRecognize",
  "收货地址（中）": "companyInfo.shippingAddressChinese",
  "收货地址（英）": "companyInfo.shippingAddressEnglish",
  收货人: "companyInfo.recipient",
  收货电话: "companyInfo.recipientPhone",
  "联系人（中）": "companyInfo.contactChinese",
  "联系人（英）": "companyInfo.contactEnglish",
  女士: "companyInfo.ms",
  先生: "companyInfo.mr",
  "+ 添加": "companyInfo.addButton",
  微信号码: "companyInfo.weChatNumber",
  "+ 添加关联公司": "companyInfo.linkCompany",
  联系人籍贯: "companyInfo.contactsHometown",
  联系人性格: "companyInfo.personality",
  联系人爱好: "companyInfo.interests",
  绑定谈判人: "companyInfo.linkedNegotiator",
  设为默认联系人: "companyInfo.setAsDefaultContact",
  提交联系人资料: "companyInfo.saveContact",
  添加地址: "companyInfo.addAddress",
  编辑地址: "companyInfo.editAddress",
  添加联系人: "companyInfo.addContact",
  "添加/编辑联系人": "companyInfo.addEditContact",
  请输入公司中文名称: "companyInfo.enterTheCompanyNameInChinese",
  请输入公司英文名称: "companyInfo.enterTheCompanyNameInEnglish",
  请输入公司简称: "companyInfo.enterAShortCompanyName",
  请输入公司税号: "companyInfo.enterTheTaxId",
  请输入供应商编码: "companyInfo.enterTheSupplierCode",
  搜索需要绑定的公司名称: "companyInfo.searchForACompanyToLink",
  请输入姓名: "companyInfo.enterAName",
  请输入公司电话: "companyInfo.enterTheCompanyPhone",
  请输入公司地址: "companyInfo.enterTheCompanyAddress",
  上传企业logo: "companyInfo.uploadCompanyLogo",
  请输入开户银行: "companyInfo.enterTheBankName",
  请输入开户支行: "companyInfo.enterTheBankBranch",
  "请输入Bank Code": "companyInfo.enterTheBankCode",
  请输入银行简称: "companyInfo.enterAShortBankName",
  请输入银行账号: "companyInfo.enterTheBankAccount",
  请输入银联号: "companyInfo.enterTheBankRoutingNumber",
  "请输入Swift Code": "companyInfo.enterTheSwiftCode",
  请选择: "companyInfo.select",
  请输入应用领域名称: "companyInfo.enterAnApplication",
  上传图片: "companyInfo.uploadImage",
  请输入品牌名称: "companyInfo.enterABrandName",
  "请填写公司介绍，500字以内":
    "companyInfo.describeYourCompanyInUpTo500Characters",
  证书标题: "companyInfo.certificateTitle",
  上传文件: "companyInfo.uploadFile",
  暂无收货地址: "companyInfo.noShippingAddresses",
  暂无联系人: "companyInfo.noContacts",
  "搜索地址、收货人、电话号码等": "companyInfo.searchAddressRecipientOrPhone",
  暂无子公司: "companyInfo.noSubsidiaries",
  "“粘贴识别”并输入文本，智能识别公司资料信息并填充":
    "companyInfo.pasteCompanyDetailsHereForAutomaticRecognitionAndFilling",
  请填写中文收货地址: "companyInfo.enterTheShippingAddressInChinese",
  请填写英文收货地址: "companyInfo.enterTheShippingAddressInEnglish",
  请填写收货人: "companyInfo.enterTheRecipient",
  请填写收货电话: "companyInfo.enterTheRecipientPhone",
  请填写联系人中文名称: "companyInfo.enterTheContactNameInChinese",
  请填写联系人英文名称: "companyInfo.enterTheContactNameInEnglish",
  请填写手机号码: "companyInfo.enterAMobileNumber",
  请填写微信号码: "companyInfo.enterAWechatId",
  请填写座机: "companyInfo.enterALandlineNumber",
  请填写绑定公司: "companyInfo.enterTheLinkedCompany",
  请填写联系人籍贯: "companyInfo.enterTheContactsHometown",
  搜索需要绑定的谈判人电话号码: "companyInfo.searchANegotiatorByPhone",
  银行付款资料上传成功: "companyInfo.bankPaymentDetailsUploaded",
  保存成功: "companyInfo.savedSuccessfully",
  保存失败: "companyInfo.couldNotSave",
  默认联系人设置成功: "companyInfo.defaultContactUpdated",
  "确认删除该联系人?": "companyInfo.deleteThisContact",
  "确认删除该地址?": "companyInfo.deleteThisAddress",
  "确认删除该公司?": "companyInfo.deleteThisCompany",
  "确认删除该银行账户?": "companyInfo.deleteThisBankAccount",
  提示: "companyInfo.confirm",
  删除成功: "companyInfo.deletedSuccessfully",
  可在手机号中继续补充多个号码: "companyInfo.youCanAddMoreMobileNumbers",
  可在微信号码中继续补充多个微信: "companyInfo.youCanAddMoreWechatIds",
  添加关联公司: "companyInfo.linkACompany",
  "缺少企业ID，无法保存联系人":
    "companyInfo.cannotSaveContactCompanyIdIsMissing",
  默认收货地址设置成功: "companyInfo.defaultShippingAddressUpdated",
  请选择图片文件: "companyInfo.selectAnImageFile",
  请先选择图片或输入文本: "companyInfo.selectAnImageOrEnterTextFirst",
  识别成功: "companyInfo.informationRecognized",
  识别失败: "companyInfo.recognitionFailed",
  "识别失败，请重试": "companyInfo.recognitionFailedPleaseTryAgain",
  "缺少企业ID，无法保存地址": "companyInfo.cannotSaveAddressCompanyIdIsMissing",
  批量管理: "companyInfo.batchManagement",
  新建公司: "companyInfo.newCompany",
  切换绑定公司: "companyInfo.switchLinkedCompany",
  编辑银行账户: "companyInfo.editBankAccount",
  添加银行账户: "companyInfo.addBankAccount",
});
export const companyInfoUiKey = (value) =>
  typeof value === "string" && Object.hasOwn(companyInfoUiKeys, value)
    ? companyInfoUiKeys[value]
    : null;
